import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  resetPasswordForm = new FormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};

  fields: FormlyFieldConfig[] = [
    {
      key: 'username',
      type: 'input',
      templateOptions: {
        required: true,
        type: 'text',
        label: 'username or email associated with your account',
        appearance: 'outline'
      },
    },
  ];
  constructor(private router: Router) {}

  ngOnInit(): void {}

  cancelPasswordReset() {
    this.resetPasswordForm.reset()
    this.router.navigate(['auth/login'])
  }

  submit() {
    if (this.resetPasswordForm.valid) {
      alert(JSON.stringify(this.model));
      this.router.navigate(['auth/confirmation'])
    }
  }
}
